import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 



const SubscriptionScheduleCreate = ()=>{
     const [scheduletime, setScheduletime ] = useState('');
     const [sdpService, setSdpService] = useState([]);
     const [message, setMessage ] = useState('');
     const [sdpserviceId, setSdpserviceId] = useState(0);
     const [page, setPage] = useState(1);
     const [lastPage, setLastPage] = useState(1);
   
     const [redirect, setRedirect] = useState(false);
     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`sdpService?page=${page}`);
            
            setSdpService(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);

     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('subscriptionSchedule', {
            schedule_time:scheduletime,
            message,
            sdp_service_id:parseInt(sdpserviceId), 
        });
        //console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/subscriptionSchedule'} />
    }
     return (
         <Wrapper pageTitle={"New SubscriptionSchedule"}>
            <InnerNav createLink={'/subscriptionScheduleCreate'} listLink={'/subscriptionSchedule'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >

                <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Sdp Service </span>
                        <select
                            className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                            placeholder="Sdpservice"
                            onChange = {e => setSdpserviceId(e.target.value)}>
                                <option value="0">Choose Service</option>

                                {sdpService.map((sdpService)=>{
                                         return(
                                            <option key={sdpService.id} value={sdpService.id}>
                                                {sdpService.service_name}
                                            </option>
                                         );
                                     })
                                 }

                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Message </span>
                        <textarea
                            
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Message"
                        onChange = {e => setMessage(e.target.value)} rows="7"></textarea>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Schedule Time </span>
                        <input type="datetime-local"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Schedule Time"
                        onChange = {e => setScheduletime(e.target.value)} />
                    </label>

                   

                 

              

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default SubscriptionScheduleCreate;